module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/map/direction-1-884cd2d5e023ddb71fad05e1421a51f8.svg";